module.exports = __webpack_public_path__ + "static/media/BLACK HANDS 6..ce8ebc77.png";